import { render, staticRenderFns } from "./IncompatibleSamplesModal.vue?vue&type=template&id=c06438d8&scoped=true"
import script from "./IncompatibleSamplesModal.vue?vue&type=script&lang=js"
export * from "./IncompatibleSamplesModal.vue?vue&type=script&lang=js"
import style0 from "./IncompatibleSamplesModal.vue?vue&type=style&index=0&id=c06438d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06438d8",
  null
  
)

export default component.exports